<template>
  <div class="question-container">
    <div v-if="mode == 0">
      <div class="row">
        <div class="col-md-5 d-flex pl-0" style="flex-flow: row wrap;">
          <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question.isSkippable">Optional</span>
          <div v-if="answer.questionType == 'ImageCapture'" ref="image-capture-video-popup">
            <div class="image-capture-iframe" v-html="answer.questionInformation" />
          </div>
        </div>

        <div class="col-md-7 d-flex" v-if="preventPIIAccessFromRoles">
          <template v-if="answer && answer.answerText">
            <div v-if="answer.isQrCode">
              <p>{{ answer[JsonFieldToDisplay()] }}</p>
            </div>
            <div v-else class="image-capture-modal-content">
              <img alt="" @contextmenu.prevent :src="!!answer.thumbnailUrls[0] ? answer.thumbnailUrls[0] : answer.imageUrls[0]" class="participant-response__img-response" />
              <div class="image-capture-modal">
                <a class="btn open-image-modal rounded-0" data-toggle="modal" :data-target="`#${answer.questionId}-questionID`"><img @contextmenu.prevent src="static/img/ICN_Fullscreen.svg" alt="" height="20" width="20"/></a>
              </div>

              <!-- Image capture Modal -->
              <div class="modal fade" :id="`${answer.questionId}-questionID`" tabindex="-1" role="dialog" aria-labelledby="ImageModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">CLOSE <i class="fa fa-times"></i></span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <img alt="" @contextmenu.prevent :src="answer.imageUrls[0]" class="image-capture-modal-image" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div v-else>
          <template v-if="answer">
            <div v-if="!answer.isSkipped">
              <p>{{ answer.answerText }}</p>
              <p v-if="answer.startTime">{{ new Date(answer.startTime) | formatGMTDate }}</p>
            </div>
          </template>
        </div>

        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="preventPIIAccessFromRoles && showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ answer.score }}
            </div>
          </div>
        </template>
        <template v-else-if="question.isSkippable">
          <div class="ml-25 d-inline-block pt-20" v-if="preventPIIAccessFromRoles && showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ question.skipScore || 0 }}
            </div>
          </div>
        </template>
      </div>
    </div>

    <div v-if="mode == 1">
      <div class="row">
        <div class="col-md-5 d-flex pl-0" style="flex-flow: row wrap;">
          <span class="index-no" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="question.isSkippable">Optional</span>
          <span v-if="isQuestionSkipped()" class="skipped-question-box ml-15 d-inline-box pt-2">
            Skipped
          </span>
          <div v-if="answer.questionType == 'ImageCapture'" ref="image-capture-video-popup">
            <div class="image-capture-iframe" v-html="answer.questionInformation" />
          </div>
        </div>

        <div class="col-md-7" v-if="preventPIIAccessFromRoles" :class="isQuestionSkipped() ? 'disable-question' : ''">
          <template v-if="answer && answer.answerText">
            <div v-if="answer.isQrCode">
              <p>{{ answer[JsonFieldToDisplay()] }}</p>
            </div>
            <div v-else class="image-capture-modal-content">
              <img alt="" @contextmenu.prevent :src="!!answer.thumbnailUrls[0] ? answer.thumbnailUrls[0] : answer.imageUrls[0]" class="participant-response__img-response" />
              <div class="image-capture-modal">
                <a class="btn open-image-modal rounded-0" data-toggle="modal" :data-target="`#${answer.questionId}-questionID`"><img @contextmenu.prevent src="static/img/ICN_Fullscreen.svg" alt="" height="20" width="20"/></a>
              </div>

              <!-- Image capture Modal -->
              <div class="modal fade" :id="`${answer.questionId}-questionID`" tabindex="-1" role="dialog" aria-labelledby="ImageModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">CLOSE <i class="fa fa-times"></i></span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <img alt="" @contextmenu.prevent :src="answer.imageUrls[0]" class="image-capture-modal-image" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div v-else>
          <template v-if="answer">
            <div>
              <p>{{ answer.answerText }}</p>
              <p>{{ new Date(answer.startTime) | formatGMTDate }}</p>
            </div>
          </template>
        </div>

        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="preventPIIAccessFromRoles && showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ answer.score }}
            </div>
          </div>
        </template>

        <template v-else-if="question.isSkippable">
          <div class="ml-25 d-inline-block pt-20" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="preventPIIAccessFromRoles && showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ question.skipScore || 0 }}
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- RESPONSE MODE -->
    <div v-else-if="mode == 2">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <div class="row">
            <div class="col-md-12 d-flex p-0 answers">
              <span class="changed" v-if="answer && answer.edit_status == 1"></span>
              <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
              <template v-if="activityType == 'activity'">
                <span class="question-text" v-html="question.formattedBody"></span>
              </template>
              <template v-else>
                <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
                <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
              </template>
              <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question.isSkippable">Optional</span>
            </div>
            <!-- CURRENT ANSWER -->
            <div v-if="preventPIIAccessFromRoles">
              <div class="col-md-12 d-flex pl-30">
                <template v-if="answer && answer.answer_text">
                  <div v-if="answer.isQrCode">
                    <p>{{ answer[JsonFieldToDisplay()] }}</p>
                  </div>
                  <div v-else class="image-capture-modal-content">
                    <img alt="" @contextmenu.prevent :src="!!answer.thumbnailUrls[0] ? answer.thumbnailUrls[0] : answer.imageUrls[0]" class="participant-response__img-response" />
                    <div class="pl-15 image-capture-modal">
                      <a class="btn open-image-modal rounded-0" data-toggle="modal" :data-target="`#${answer.questionId}-questionID`"><img @contextmenu.prevent src="static/img/ICN_Fullscreen.svg" alt="" height="20" width="20"/></a>
                    </div>

                    <!-- Image capture Modal -->
                    <div class="modal fade" :id="`${answer.questionId}-questionID`" tabindex="-1" role="dialog" aria-labelledby="ImageModalCenterTitle" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">CLOSE <i class="fa fa-times"></i></span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <img alt="" @contextmenu.prevent :src="answer.imageUrls[0]" class="image-capture-modal-image" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <template v-if="answer && answer.answer_text">
                <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity' && answer.score != null">
                  <label class="fs-12">Score</label>
                  <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                    {{ answer.score }}
                  </div>
                </div>
              </template>
              <template v-else-if="question.isSkippable">
                <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                  <label class="fs-12">Score</label>
                  <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                    {{ question.skipScore || 0 }}
                  </div>
                </div>
              </template>
            </div>
            <div v-else>
              <template v-if="answer">
                <div>
                  <p>{{ answer.answer_text }}</p>
                  <p>{{ new Date(answer.start_time) | formatGMTDate }}</p>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="col-md-7 previous-answer" v-if="answer && answer.edit_status == 1">
          <div>
            <span class="previous-value-mark"></span>
            <div class="previous-value ml-3">PREVIOUS RESPONSE</div>

            <template v-if="answer && answer.privius_answer_text">
              <div>
                <span class="text-align">{{ selectedLanguageCulture == "EN" ? answer.privius_answer_text : answer.privius_display_answer_text }}</span>
              </div>

              <div v-if="answer.isQrCode">
                <p>{{ answer[privius_answer_text] }}</p>
              </div>
              <div v-else class="d-flex participant-history-image mr-10">
                <img alt="" @contextmenu.prevent :src="!!answer.thumbnailUrls[0] ? answer.thumbnailUrls[0] : answer.imageUrls[0]" class="participant-response__img-response" />
              </div>
              <div class="row">
                <div class="d-inline-block ml-0 pt-10" v-if="showScore && answer.privius_score != null">
                  <label>Score</label>
                  <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                    {{ answer.privius_score }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="question.isSkippable">
              <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                <label class="fs-12">Score</label>
                <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                  {{ question.skipScore || 0 }}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import activityCommonMixin from "./activity-common-mixin";
import { mapGetters } from "vuex";
import { AclRule } from "vue-acl";
import { PI, SYSTEM_ADMIN, STUDY_ADMIN, STUDY_MANAGER, CRA, DM, QUALITY, BSTAT, PHV, HOME_HEALTH, CraUB, SUPPORT } from "@/constants/authRoles";
import { loadData } from "@/services/video-render";
export default {
  name: "ImageCaptureResponse",
  mixins: [activityCommonMixin],
  data() {
    return {};
  },
  props: {
    mode: Number,
    answer: Object,
    usage: Object,
    stepIndex: Number,
    surveyData: Object,
    selectedLanguageCulture: String,
    question: Object,
    activityType: String
  },
  mounted() {
    loadData(this.$refs["image-capture-video-popup"]);
  },
  computed: {
    ...mapGetters(["user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canSysAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyManagerAccess() {
      this.$acl.change(`${STUDY_MANAGER}`);
      return this.$acl.check("userAccess");
    },
    canCraAccess() {
      this.$acl.change(`${CRA}`);
      return this.$acl.check("userAccess");
    },
    canDmAccess() {
      this.$acl.change(`${DM}`);
      return this.$acl.check("userAccess");
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    canQualityAccess() {
      this.$acl.change(`${QUALITY}`);
      return this.$acl.check("userAccess");
    },
    canHomeHealthAccess() {
      this.$acl.change(`${HOME_HEALTH}`);
      return this.$acl.check("userAccess");
    },
    canBioStatisticsAccess() {
      this.$acl.change(`${BSTAT}`);
      return this.$acl.check("userAccess");
    },
    canPharmacovigilanceAccess() {
      this.$acl.change(`${PHV}`);
      return this.$acl.check("userAccess");
    },
    canCraUBAccess() {
      this.$acl.change(`${CraUB}`);
      return this.$acl.check("userAccess");
    },
    canSupportAccess() {
      this.$acl.change(`${SUPPORT}`);
      return this.$acl.check("userAccess");
    },
    preventPIIAccessFromRoles() {
      const roles = this.canSysAdminAccess || this.canStudyAdminAccess || this.canStudyManagerAccess || this.canCraAccess || this.canDmAccess || this.canQualityAccess || this.canBioStatisticsAccess || this.canPharmacovigilanceAccess || this.canCraUBAccess || this.canSupportAccess;
      return !roles;
    }
  },
  methods: {
    isQuestionSkipped() {
      return this.answer.isSkipped;
    }
  }
};
</script>
<style lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.participant-response__img-response {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
}

.changed {
  position: absolute;
  left: -29px;
  top: 0;
  width: 18px;
  height: 51px;
  border-radius: 1px;
  background-color: #f5a623;
}
.image-capture-modal {
  left: 92px;
  position: absolute;
  top: 61px;
}
.image-capture-modal .open-image-modal {
  position: relative;
  top: 100%;
  right: 100%;
  background-color: #d7dfeb;
}
.image-capture-modal-content .modal-content {
  background-color: transparent !important;
  border: none !important;
}

.image-capture-modal-content .modal-header {
  border: none !important;
  padding: 0 !important;
}
.image-capture-modal-content .close {
  background-color: transparent !important;
  border: 0 !important;
  color: #fff !important;
  font-family: Roboto !important;
  font-size: 14px !important;
  font-weight: normal !important;
  text-shadow: inherit;
  opacity: 1;
}

.image-capture-modal-content .modal-body {
  border: none !important;
  padding: 0 !important;
}

.image-capture-modal-body .download {
  text-align: left;
  width: 100%;
  color: black;
  background-color: #d7dfeb;
}

.image-capture-modal-image {
  max-width: 400px;
  max-height: 704px;
  widows: auto;
  height: auto;
}

.image-capture-modal-content {
  width: 110px;
  height: 100px;
  background: #0d0c0c;
  text-align: center;
  position: relative;
}
</style>
